<template>
 <div class="">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox">
        <el-form-item label="创建时间:" class="item2">
          <el-date-picker
            v-model="searchFrom.createTimes"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="司机姓名:">
          <el-input placeholder="" v-model="searchFrom.driverName"></el-input>
        </el-form-item>
        <el-form-item label="司机电话:">
          <el-input placeholder="" v-model="searchFrom.driverPhone"></el-input>
        </el-form-item>
        <el-form-item label="保险公司:">
          <el-select  v-model="searchFrom.insuranceCompany" filterable  placeholder="请选择" >
            <el-option v-for="item in gysList" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属小队:">
          <el-select v-model="searchFrom.teamOrgName" filterable placeholder="请选择" clearable  >
            <el-option v-for="item in XDList" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="保险单号:" prop="insuranceNo">
          <el-input placeholder="" v-model="searchFrom.insuranceNo" ></el-input>
        </el-form-item>
        </div>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn" v-if="btnFlg[0]">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary" @click="exportFn" size="mini" :disabled="isDisable" v-if="btnFlg[1]">导出</el-button>
            <el-button type="primary" @click="addFn" size="mini" v-if="btnFlg[2]">新增</el-button>
            <el-button type="primary" @click="delFn" size="mini" v-if="btnFlg[3]">删除</el-button>
            <el-button type="primary" @click="importFn" size="mini" v-if="btnFlg[4]">导入</el-button>
            <el-button type="primary" size="mini" @click="modelDown" v-if="btnFlg[5]">模板下载</el-button>
          </div>
          <div class="tongjiBox">
             <el-form-item style="margin-left:8px">
                <p class="margin0" >
                  实际保费合计<span class="red">{{sum.totalActualPremiumAmount}}</span>元
                </p>
              </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" @selection-change="selectGoods" @row-click="handleRowClick" style="width: 100%" height="100%" center border class="tableComent" :cell-class-name="cellClassName">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column  type="index" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="100" >
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="pingzhengFn(scope.row)" v-if="btnFlg[6]">凭证</el-button>
              <el-button type="text" size="mini" @click="editFn(scope.row)" v-if="btnFlg[7]">修改</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="insuranceNo" label="保险单号" min-width="190"></el-table-column>
        <el-table-column prop="driverName" label="司机姓名" min-width="80"></el-table-column>
        <el-table-column prop="driverPhone" label="司机电话" min-width="120"></el-table-column>
        <el-table-column prop="teamOrgName" label="小队" min-width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="insuranceCompany" label="保险公司" min-width="150"></el-table-column>
        <el-table-column prop="insuranceProject" label="保险项目" min-width="150"></el-table-column>
        <el-table-column prop="insuranceCosts" label="保费(元)" width="110"></el-table-column>
        <el-table-column label="保险起止日期" width="170" >
          <template slot-scope="scope">
            <div>
              <span>{{ getCurrentTime(scope.row.insuranceDateFrom) }} ~ </span>
              <span>{{ getCurrentTime(scope.row.insuranceDateTo) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="dailyPremiumAmount" label="日保费金额(元)" width="120" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="actualPremiumAmount" label="实际保费金额(元)" width="130" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="insuranceDays" label="保险到期提醒" width="110">
          <template slot-scope="scope">
            <div :class="{'red-cell': scope.row.insuranceDays < 30}">
              {{ scope.row.insuranceDays }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人"  min-width="80"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="dateTimeFormat" width="170"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加 -->
    <el-dialog :title="isAdd?'添加':'修改'" :close-on-click-modal="false" :close-on-press-escape="false" @close="closeDialog" :visible.sync="addFlag" width="750px" center>
      <div>
        <el-form :inline="true" :rules="rules" ref="addForm" :model="addForm" class="demo-form-inline jiaoyan" label-width="120px" size="mini" v-if="addFlag">
          <el-form-item label="司机姓名:" prop="driverId" class="width1" >
            <el-select v-model="addForm.driverId" filterable placeholder="请选择" @change="sijiChange">
              <el-option v-for="item in sijiList" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <br>
          <el-form-item label="小队:" prop="teamOrgCode" class="width1">
            <el-select v-model="addForm.teamOrgCode" filterable placeholder="请选择" clearable :disabled="true">
              <el-option v-for="item in XDList" :label="item.name" :value="item.code" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="司机电话:" prop="driverPhone" class="width1" >
            <el-input placeholder="" maxlength="50" v-model="addForm.driverPhone" :readonly="true"></el-input>
          </el-form-item>
          <br>
          <el-form-item label="保险公司" prop="insuranceCompany" class="width1">
            <el-select v-model="addForm.insuranceCompany" filterable placeholder="请选择">
              <el-option v-for="item in gysList" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="保险项目:" prop="insuranceProject" class="width1">
            <el-select v-model="addForm.insuranceProject" filterable  placeholder="请选择">
              <el-option v-for="item in BXXiangMu" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="保险单号:" prop="insuranceNo">
            <el-input placeholder="" v-model="addForm.insuranceNo"></el-input>
          </el-form-item>
          <el-form-item label="保费:" prop="insuranceCosts" class="jiage" >
            <el-input placeholder="" v-number-input.float="2" maxlength="8" v-model="addForm.insuranceCosts"></el-input>
            <span class="danwei" >元</span>
          </el-form-item>
           <br>
          <el-form-item label="保险开始日期:" prop="insuranceDateFrom" class="jiage" >
            <el-date-picker
              v-model="addForm.insuranceDateFrom"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期时间"
              @change="handleDateChange"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="保险结束日期:" prop="insuranceDateTo" class="jiage" >
            <el-date-picker
              v-model="addForm.insuranceDateTo"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期时间"
              @change="handleDateChange"
            ></el-date-picker>
          </el-form-item>
          <br>
          <el-form-item label="日保费金额:" prop="dailyPremiumAmount" class="jiage" v-if="addForm.insuranceProject === '雇主险'">
            <el-input placeholder="" v-number-input.float="2" maxlength="8" v-model="addForm.dailyPremiumAmount" :readonly="true"></el-input>
            <span class="danwei" >元</span>
          </el-form-item>
          <br>
          <el-form-item label="凭证:" class="remark" prop="remark" v-if="addFlag" >
             <uploadImgs :imgList.sync='imgList' :max=3 @remove="remove"></uploadImgs>
          </el-form-item>
          <br>
          <!-- <el-form-item label="申请备注:" class="remark" prop="remark" >
            <el-input  placeholder=""  maxlength="500" v-model="addForm.remark"></el-input>
          </el-form-item> -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFlag = false">取 消</el-button>
        <el-button type="primary" @click="saveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 凭证 -->
    <el-dialog  title="凭证" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="pzFlag" width="660px" center>
      <div class="fujianBox">
         <div class="imgBox">
            <el-image
              v-for="(item,index) in pzList" :src="item.fileKeyUrl" :key="index" :preview-src-list="getSrcList(index,pzList)">

            </el-image>
          </div>
      </div>
    </el-dialog>
    <el-image-viewer v-if="dialogImg"  :on-close="closeViewer" :url-list="lookimgList" />
    <!-- 导入 -->
    <importC v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, toFixed, emptyFn } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { getDictionaryDetailList } from '@/api/newTMS'
import { organizationTree, cDlists, driverInsuranceList, driverInsuranceUpdateInsurance, driverInsuranceImport, getFileShow,
  driverInsuranceListTotal, driverInsuranceDeletes } from '@/api/vgs-driver2.0'
import uploadImgs from '@/views/newTMS/publicFiles/uploadImgs.vue'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import importC from '@/components/import.vue'
export default {
  components: {
    uploadImgs, ElImageViewer, importC
  },
  data () {
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      isDisable: false,
      sum: {},
      rules: {
        teamOrgCode: [
          { required: true, message: '请选择小队', trigger: 'blur' }
        ],
        driverId: [
          { required: true, message: '请选择司机', trigger: 'blur' }
        ],
        insuranceProject: [
          { required: true, message: '请选择保险项目', trigger: 'blur' }
        ],
        insuranceCompany: [
          { required: true, message: '请选择保险公司', trigger: 'blur' }
        ],
        insuranceCosts: [
          { required: true, message: '请输入保费', trigger: 'blur' }
        ],
        insuranceNo: [
          {
            validator: (rule, value, callback) => {
              // 只有当不是工伤保险时才进行必填校验
              if (this.addForm.insuranceProject !== '工伤保险') {
                if (!value || value.trim() === '') {
                  callback(new Error('请输入保险单号'))
                } else {
                  callback()
                }
              } else {
                callback() // 工伤保险时直接通过，不校验
              }
            },
            trigger: 'blur'
          }
        ],
        auditReject: [
          { required: true, message: '请输入驳回原因', trigger: 'blur' }
        ],
        auditStatus: [
          { required: true, message: '请选择审核状态', trigger: 'blur' }
        ],
        insuranceDateFrom: [
          { required: true, message: '请选择保单开始日期', trigger: 'blur' }
        ],
        insuranceDateTo: [
          { required: true, message: '请选择保险结束日期', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (this.addForm.insuranceDateFrom && value) {
                if (new Date(value) <= new Date(this.addForm.insuranceDateFrom)) {
                  callback(new Error('保险结束日期必须大于开始日期'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]

      },
      isAdd: false,
      addFlag: false,
      addForm: {
        insuranceDateFrom: '', // 保险开始日期
        insuranceDateTo: '' // 保险结束日期
      },
      deleteAttachmentsIds: [],
      imgList: [],
      gysList: [], // 保险公司
      BXXiangMu: [], // 保险项目
      XDList: [],
      sijiList: [],
      pzList: [],
      pzFlag: false,
      dialogImg: false,
      lookimgList: [],
      importDialog: false,
      btnFlg: [],
      btnIdArr: ['01N01Y0100', '01N01Y0200', '01N01Y0300', '01N01Y0400', '01N01Y0500', '01N01Y0600', '01N01Y0700', '01N01Y0800']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    this.searchFn()
    getDictionaryDetailList({ dictionaryType: 'insurance_type' }).then(res => { this.gysList = res })
    getDictionaryDetailList({ dictionaryType: 'insurance_project' }).then(res => { this.BXXiangMu = res })
    cDlists({ driverClassify: 2, tenantId: localStorage.getItem('tenantCode') }).then(res => { this.sijiList = res })
    organizationTree({ flag: 1 }).then((res) => {
      if (res[0].orgType == 1) {
        this.XDList = res[0].children
      } else {
        this.XDList = res
      }
    })
  },
  mounted () {
    this.$nextTick(() => {
      let h = this.$refs.searchBox.offsetHeight
      let pH = document.documentElement.clientHeight
      this.h = (pH - h - 203) + 'px'
    })
  },
  computed: {
    isInsuranceNoRequired () {
      return this.addForm.insuranceProject !== '工伤保险'
    }
  },
  watch: {
  // 新增监听保险项目变化
    'addForm.insuranceProject': {
      handler (newVal) {
      // 切换保险项目时，重新校验保险单号
        if (this.$refs.addForm) {
          this.$refs.addForm.validateField('insuranceNo')
        }
        // 如果不是雇主险，清空日保费金额
        if (newVal !== '雇主险') {
          this.addForm.dailyPremiumAmount = ''
        } else {
        // 如果是雇主险，重新计算日保费金额
          this.calculateDailyPremium()
        }
      },
      immediate: true
    },
    // 监听保险金额变化
    'addForm.insuranceCosts': {
      handler () {
        if (this.addForm.insuranceProject === '雇主险') {
          this.calculateDailyPremium()
        }
      },
      immediate: true
    },
    // 监听开始日期变化
    'addForm.insuranceDateFrom': {
      handler () {
        if (this.addForm.insuranceProject === '雇主险') {
          this.calculateDailyPremium()
        }
      },
      immediate: true
    },
    // 监听结束日期变化
    'addForm.insuranceDateTo': {
      handler () {
        if (this.addForm.insuranceProject === '雇主险') {
          this.calculateDailyPremium()
        }
      },
      immediate: true
    }
  },
  methods: {
    // 计算日保费金额
    calculateDailyPremium () {
      const { insuranceCosts, insuranceDateFrom, insuranceDateTo } = this.addForm

      // 检查必要字段是否存在
      if (!insuranceCosts || !insuranceDateFrom || !insuranceDateTo) {
        this.addForm.dailyPremiumAmount = ''
        return
      }

      // 计算日期差（天数），包含当天
      const startDate = new Date(insuranceDateFrom)
      const endDate = new Date(insuranceDateTo)
      // 包含当天：天数 = (结束日期 - 开始日期) / 毫秒数 + 1
      const timeDiff = endDate.getTime() - startDate.getTime()
      const daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24)) + 1

      // 检查天数是否有效（至少1天）
      if (daysDiff <= 0) {
        this.addForm.dailyPremiumAmount = ''
        return
      }

      // 计算日保费金额 = 保险金额 / 天数，保留两位小数
      const dailyAmount = Number(insuranceCosts) / daysDiff
      this.addForm.dailyPremiumAmount = dailyAmount.toFixed(2)
    },
    // 导入
    importFn () {
      this.importDialog = true
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/tms/excel/司机保险导入模板.xlsx'// 后更改页面地址
    },
    DRsave (formData) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      // formData.append('params', JSON.stringify({ id: '' }))
      // formData.append('businessType', 4)
      driverInsuranceImport(formData).then(res => {
        loading.close()
        this.importDialog = false
        var that = this
        this.msg = this.$message({
          showClose: true,
          message: res,
          duration: 3000,
          type: 'success',
          onClose () {

          }
        })
        this.getList(this.searchFrom)
      }).catch(err => {
        if (err.code == -1) {
          this.$message({
            type: 'warning',
            message: err.data ? err.data : err.message,
            onClose () {
              loading.close()
            }
          })
          this.isDisable = false
        } else if (err.code == 1) {
          this.isDisable = false
          this.$confirm('存在异常信息，是否确认导出异常信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在导出异常信息...'
            })
            let form = {}
            exportExcel(
              this.global.driverNameT + '/driverInsurance/exportDriverInsuranceExc',
              form,
              '异常信息表'
            )
            setTimeout(() => {
              this.$message({
                type: 'success',
                message: '异常信息导出成功'
              })
              loading.close()
              this.daoRuMark = false
              this.importDialog = false
              this.getList(this.searchFrom)
            }, 3000)
          }).catch(() => {
            this.daoRuMark = false
            this.$message({
              type: 'warning',
              message: '已取消异常信息导出，' + err.data,
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          loading.close()
        }
      })
    },
    destroy () {
      this.importDialog = false
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 日期变化时触发校验
    handleDateChange () {
      // 触发结束日期的重新校验
      if (this.addForm.insuranceDateTo) {
        this.$refs.addForm.validateField('insuranceDateTo')
      }
      // 如果是雇主险，重新计算日保费金额
      if (this.addForm.insuranceProject === '雇主险') {
        this.calculateDailyPremium()
      }
    },
    // 凭证
    pingzhengFn (row) {
      getFileShow({ businessType: 'driverInsurance', businessId: row.id }).then(res => {
        if (res.length == 0) {
          this.$alert('暂无可查看的凭证', '系统提示')
          return
        }
        this.lookimgList = []
        res.forEach((item, index) => {
          this.$set(this.lookimgList, index, item.fileKeyUrl)
        })

        this.dialogImg = true
      })
    },
    closeViewer () {
      this.dialogImg = false
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      let imgArr = arr.slice(index).concat(arr.slice(0, index))
      let urls = []
      imgArr.forEach(item => {
        urls.push(item.fileKeyUrl)
      })
      return urls
    },
    sijiChange (e) {
      if (e) {
        let json = this.sijiList.filter(item => item.id == e)
        this.$set(this.addForm, 'driverName', json[0].name)
        this.$set(this.addForm, 'driverPhone', json[0].mobile)
        this.$set(this.addForm, 'idNumber', json[0].identityNo)
        this.$set(this.addForm, 'teamOrgId', json[0].teamOrgId)
        this.$set(this.addForm, 'teamOrgName', json[0].teamOrgName)
        this.$set(this.addForm, 'teamOrgCode', json[0].teamOrgCode)
        this.$set(this.addForm, 'teamName', json[0].teamOrgName)
        this.$set(this.addForm, 'teamId', json[0].teamOrgId)
      }
    },
    xiaoduiChange (e) {
      if (e) {
        let json = this.XDList.filter(item => item.code == e)
        this.$set(this.addForm, 'teamOrgName', json[0].name)
        this.$set(this.addForm, 'teamOrgCode', json[0].code)
        this.$set(this.addForm, 'teamOrgId', json[0].id)
        cDlists({ driverClassify: 2, teamOrgId: json[0].id }).then(res => {
          this.sijiList = res
        })
        this.$set(this.addForm, 'driverId', null)
        this.$set(this.addForm, 'driverName', null)
        this.$set(this.addForm, 'driverPhone', null)
        this.$set(this.addForm, 'idNumber', null)
      }
    },
    // 添加
    addFn () {
      this.isAdd = true
      this.addFlag = true
      this.imgList = []
      this.addForm = {
        insuranceDateFrom: '', // 保险开始日期
        insuranceDateTo: '',
        dailyPremiumAmount: '' // 清空日保费金额
      }
    },
    // 修改
    editFn (row) {
      this.addForm = { ...row }
      this.deleteAttachmentsIds = []
      if (row.insuranceProject !== '雇主险') {
        this.addForm.dailyPremiumAmount = ''
      }
      this.$set(this.addForm, 'insuranceDateFrom', this.getCurrentTime(row.insuranceDateFrom))
      this.$set(this.addForm, 'insuranceDateTo', this.getCurrentTime(row.insuranceDateTo))
      this.imgList = []
      cDlists({ driverClassify: 2, teamOrgId: row.teamOrgId }).then(res => {
        this.sijiList = res
      })
      getFileShow({ businessType: 'driverInsurance', businessId: row.id }).then(res => {
        this.isAdd = false
        this.addFlag = true
        res.forEach(item => {
          var filename = item.url.substring(item.url.lastIndexOf('/') + 1)
          this.imgList.push({ status: 'ready', url: item.fileKeyUrl, id: item.fileId, name: filename })
        })
      })
    },
    saveFn () {
      // if (this.imgList.length == 0) {
      //   this.$alert('请上传凭证', '系统提示')
      //   return
      // }
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          // 添加日期校验
          if (this.addForm.insuranceDateFrom && this.addForm.insuranceDateTo) {
            if (new Date(this.addForm.insuranceDateTo) <= new Date(this.addForm.insuranceDateFrom)) {
              this.$alert('保险结束日期必须大于开始日期', '系统提示')
              return
            }
          }
          let imgfile = new FormData()
          this.imgList.forEach(item => {
            if (!item.id) {
              imgfile.append('files', item.raw)
            }
          })
          let objData = {}
          if (this.isAdd) {
            objData = {
              insurance: this.addForm
            }
          } else {
            objData = {
              insurance: this.addForm,
              deleteAttachmentsIds: this.deleteAttachmentsIds
            }
          }
          imgfile.set('params', JSON.stringify(objData))
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          driverInsuranceUpdateInsurance(imgfile).then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.addFlag = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },
    // 删除文件
    remove (file) {
      if (file.id) {
        this.deleteAttachmentsIds.push(file.id)
      }
    },
    // 删除
    delFn () {
      let selectData = this.$refs.table.selection
      this.rowDataList = selectData
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        driverInsuranceDeletes({
          ids: selectData.map(item => item.id)
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 导出
    exportFn () {
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.driverNameT + '/driverInsurance/export',
        form,
        '司机保险列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      this.loading = true
      driverInsuranceList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        this.loading = false
      })
      driverInsuranceListTotal(this.searchFrom).then(res => {
        this.sum = res
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.searchFn()
    },
    closeDialog () {
      this.deleteAttachmentsIds = []
      this.imgLis = []
    },
    // 日期格式化
    getCurrentTime (dateStr) {
      if (!dateStr) return ''
      let date = new Date(dateStr)
      let Y = date.getFullYear()
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let D = date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()
      return Y + '-' + M + '-' + D
    },
    cellClassName ({ row, column }) {
      if (column.property === 'insuranceDays' && row.insuranceDays < 30) {
        return 'red-cell-full'
      }
      return ''
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width:430px!important;
}
/deep/.el-form{
  width: 100%;
}
.jiaoyan /deep/.el-input__inner{
      width: 180px;
}
.imgBox{
  margin:0;
}

.inpBox .dzBox  /deep/.el-input__inner {
    width: 170px;
}
.imgBox{
  /deep/.el-image{
    width: 180px;
    height: 130px;
    margin-right: 20px;
  }
}
.remark  /deep/.el-input .el-input__inner {
    width: 480px;
    height: 80px;
}
.tongjiBox{
   /deep/.el-form-item--mini .el-form-item__content,  /deep/.el-form-item--mini .el-form-item__label{
        line-height: 20px;
  }
}
.width2  /deep/.el-input .el-input__inner {
    width: 480px;
}
.formItemBox{
  /deep/.el-form-item{
    width: 24%;
  }
}
/deep/.red-cell-full {
  background-color: #f47474 !important;
  // color: #fff !important;
}
/deep/.el-input.is-disabled .el-input__inner {
  color: #333;
}
</style>
